import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BFormInput, BInputGroup, BInputGroupAppend } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataDialogSearch',
    props: {
        value: null,
        title: { default: "" }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faTimes);
        const filter = computed({
            get: () => {
                return props.value;
            },
            set: (newValue) => {
                emit("input", newValue);
            },
        });
        const placeholder = computed(() => `search ${props.title.toLowerCase()}`);
        return { __sfc: true, props, emit, filter, placeholder, FontAwesomeIcon, BButton, BFormInput, BInputGroup, BInputGroupAppend };
    }
});
